var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncollaggioYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.021,
    height: 24,
    viewBox: "0 0 24.021 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-953.982 3989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.288,369l-.949.755a14.128,14.128,0,0,1-7.011,9.1l.069,1.524-1.594,6,.587.618,5.037-3.088,1.215.062a13.891,13.891,0,0,1,8.015-8.137l.843-.925Z",
    transform: "translate(914 -4355)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.577,384.162h0a4.245,4.245,0,0,1-.878-5.374v-.013a3.36,3.36,0,0,0,.1-3.124,3.071,3.071,0,0,0-2.445-1.782l-1.034-.1a.789.789,0,0,0-.723.433.875.875,0,0,0,.036.874,8.162,8.162,0,0,1,1.125,5.822,5.19,5.19,0,0,0,.749,3.768,4.73,4.73,0,0,0,3.078,2.085,1.648,1.648,0,0,0-.011-2.585",
    transform: "translate(914 -4355)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,380.382l-1.595,6,.588.618,5.036-3.089,1.215.063a13.887,13.887,0,0,1,8.016-8.137l.842-.926L57.289,369l-.949.755a14.127,14.127,0,0,1-7.012,9.1l.07,1.524,4.029,3.529",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.006
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.761,380.894a8.164,8.164,0,0,0-1.125-5.823.875.875,0,0,1-.036-.874.79.79,0,0,1,.723-.432l1.034.1a3.071,3.071,0,0,1,2.445,1.782,3.363,3.363,0,0,1-.1,3.124v.013a4.246,4.246,0,0,0,.878,5.374,1.647,1.647,0,0,1,.011,2.584,4.725,4.725,0,0,1-3.078-2.084A5.19,5.19,0,0,1,41.761,380.894Z",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.006
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(954 -3989)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncollaggioYellow);
export default __webpack_public_path__ + "static/media/incollaggio_yellow.151c7445246c67d7241ffd8cdecba3ed.svg";
export { ForwardRef as ReactComponent };